export const STORE_SET_NAME = 'store.SET_NAME';
export const STORE_LOADED = 'store.LOADED';
export const STORE_SELECTED = 'store.SELECTED';
